//libs
import React, { useEffect, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

//components
import Carousel from 'shared/components/Carousel';
import Image from 'shared/components/ImageV2';

//styles
import { BannerContainer, ArrowRight, ArrowLeft, SlideIndex, BannerImage } from './styles';

//icons
import { useStoreIcon, IconName } from 'shared/icons';

// context
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

//selectors
import { getBannerImages } from 'shared/store/listingV2/selectors';

//helpers
import { getUrl } from './helpers';
import { getStoreUrl } from 'shared/helpers/storeUrl';

//constants
import {
  GUTTER_SPACE,
  BANNER_WIDTH,
  MAX_DWEB_WIDTH,
  SLIDE_COUNT_TEXT,
  DEFAULT_IMAGE_WIDTH,
} from './constants';

//selectors
import { getFilterWithNames } from 'shared/store/listingV2/selectors';

function TopBanner() {
  const ChevronRight = useStoreIcon(IconName.CHEVRON_RIGHT_SMALL);
  const bannerImages = useSelector(getBannerImages);
  const { deviceWidth } = useResponsiveContext();
  const isBleeding = deviceWidth <= MAX_DWEB_WIDTH;
  const slideWidth = isBleeding ? deviceWidth - GUTTER_SPACE : BANNER_WIDTH;
  const slideHeight = slideWidth / bannerImages[0].aspect_ratio;
  const [slidePosition, setSlidePosition] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const filterWithNames = useSelector(getFilterWithNames);
  useEffect(() => {
    if (bannerImages !== null) setImagesLoaded(true);
  }, [bannerImages]);

  const renderImage = useCallback(
    (idx: number, url: string) => {
      return (
        <BannerImage>
          <Image
            src={url}
            width={DEFAULT_IMAGE_WIDTH}
            aspectRatio={bannerImages[0].aspect_ratio}
            lazy={idx !== 0}
            alt={`banner-image-${idx}`}
            data-test="top-banner-img"
          />
        </BannerImage>
      );
    },
    [bannerImages]
  );

  const onBannerClick = (e: React.SyntheticEvent<HTMLAnchorElement, Event>, url: string) => {
    e.preventDefault();
    window.open(getStoreUrl(url));
  };
  if (filterWithNames.length !== 0) return null;

  return (
    <BannerContainer>
      {imagesLoaded && (
        <SlideIndex>{`${slidePosition + 1} ${SLIDE_COUNT_TEXT} ${bannerImages.length}`}</SlideIndex>
      )}
      <Carousel
        slideWidth={slideWidth}
        slideHeight={slideHeight}
        currentSlide={slidePosition}
        onChange={setSlidePosition}
        autoPlay
        navPadding={0}
        className="plp-new-banner"
        prevButton={
          imagesLoaded ? (
            <ArrowLeft leadingIcon={<ChevronRight />} kind="secondary" size="large" />
          ) : (
            <></>
          )
        }
        nextButton={
          imagesLoaded ? (
            <ArrowRight leadingIcon={<ChevronRight />} kind="secondary" size="large" />
          ) : (
            <></>
          )
        }
        customRightMargin={16}
        ignoreRightMargin
        overrideSlideStyles={{ height: 'auto', width: 'auto' }}
      >
        {bannerImages.map((img, idx: number) => {
          if (img.banner_link?.trim()) {
            const URL = getUrl(img);
            return (
              <a href={URL} onClick={(e) => onBannerClick(e, URL)} data-lcp={idx + 1} key={`banner-link-${idx}`}>
                {renderImage(idx, img.url)}
              </a>
            );
          } else {
            return <div key={`banner-img-${idx}`}>{renderImage(idx, img.url)}</div>;
          }
        })}
      </Carousel>
    </BannerContainer>
  );
}

export default TopBanner;
